import React, { useState } from 'react';
import Button from '../../../../common/components/Button/Button';
import { Modal } from 'react-bootstrap';
import DataTable from '../../../../common/components/DataTable/DataTable';
import { TableHeaderColumn } from 'react-bootstrap-table';
import formatDate from '../../../../helpers/formatDate';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import './EmailAuditModal.scss';
import formatDateTime from '../../../../helpers/formatDateTime';

const EmailAuditModal = ({ resource, resourceId }) => {
  const [showContentModal, setShowContentModal] = useState(false);

  const openModal = () => {
    setShowContentModal(true);
  };
  const closeModal = () => {
    setShowContentModal(false);
  };

  const formatSender = (sender) => (sender ? sender : 'System Generated');

  return (
    <div>
      <Button size={'xs'} label={'audit'} bsStyle={'default'} handleClick={openModal} />
      <Modal show={showContentModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Email Audit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className={'email-audit-modal--info'}>
            <Col sm={2} className={'email-audit-modal--label'}>
              Subject:
            </Col>
            <Col sm={10} className={'email-audit-modal--value'}>
              {resource.subject}
            </Col>
          </Row>
          <Row className={'email-audit-modal--info'}>
            <Col sm={2} className={'email-audit-modal--label'}>
              From:
            </Col>
            <Col sm={4} className={'email-audit-modal--value'}>
              {resource.from_address}
            </Col>
            <Col sm={1} className={'email-audit-modal--label'}>
              To:
            </Col>
            <Col sm={5} className={'email-audit-modal--value'}>
              {resource.to_address}
            </Col>
          </Row>
          <Row className={'email-audit-modal--info'}>
            <Col sm={2} className={'email-audit-modal--label'}>
              Processed:
            </Col>
            <Col sm={4} className={'email-audit-modal--value'}>
              {formatDate(resource.delivered_at)}
            </Col>

            <Col sm={1} className={'email-audit-modal--label'}>
              By:
            </Col>
            <Col sm={5} className={'email-audit-modal--value'}>
              {formatSender(resource.user)}
            </Col>
          </Row>

          <DataTable
            source={'/events'}
            autoFilters={[{ type: 'filter[resource]', value: resourceId }]}
            name="emailAuditTable"
            showTotal={true}
          >
            <TableHeaderColumn dataField="id" isKey={true} hidden={true}>
              ID
            </TableHeaderColumn>
            <TableHeaderColumn dataField="action" width={'20%'}>
              Order Of Events
            </TableHeaderColumn>

            <TableHeaderColumn
              dataField="occurredAt"
              dataFormat={formatDateTime}
              width={'15%'}
            />
          </DataTable>
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </div>
  );
};

export default EmailAuditModal;
